export const FILL_OPACITY = 0.2;
export const SHAPE_OPTIONS = {
  color: '#043AFA',
  fillColor: '#ffffff',
  fillOpacity: FILL_OPACITY
};
export const EDITABLE_SHAPE_OPTIONS = {
  color: '#FFE400 ',
  fillColor: '#ffffff',
  fillOpacity: FILL_OPACITY
};
export const SELECTED_SHAPE_OPTIONS = {
  color: '#FFE400 ',
  fillColor: '#ffffff',
  fillOpacity: FILL_OPACITY
};
